import { textDangerBase } from './colors';

// HelpText
export const helpTextDefault = '#595959';
export const helpTextDanger = textDangerBase;
